import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=b839fb90"
import script from "./Messages.vue?vue&type=script&lang=ts"
export * from "./Messages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b839fb90')) {
      api.createRecord('b839fb90', component.options)
    } else {
      api.reload('b839fb90', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=b839fb90", function () {
      api.rerender('b839fb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/requestDetails/Messages.vue"
export default component.exports